module.exports = __webpack_public_path__ + "img/operations.f0fa31f5.svg";